import reduceReducers from 'reduce-reducers';

//Siblings reducers
import organisationReducer from './organisation-reducer';
import companySiteReducer from './company-site-reducer';

export default reduceReducers(organisationReducer, companySiteReducer);
